module.exports = __webpack_public_path__ + "static/media/undraw_Online_shopping_re_k1sv.d517072e.svg";